import { AllGames, AllGamesApi, GetAllGamesRequest } from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(AllGamesApi)

const getAllGames = async (
  includeInactive?: boolean,
  includeUpcoming?: boolean,
  includeHistorical?: boolean,
): Promise<AllGames> => {
  const request: GetAllGamesRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    includeInactive,
    includeUpcoming,
    includeHistorical,
  }

  return await getApi().getAllGames(request)
}

export const GamesServiceAPI = {
  getAllGames,
}
